module.exports = __webpack_public_path__ + "img/loading.bd577c57.png";